import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { Encounter } from "@medplum/fhirtypes";

import { ORGANIZATION_ID } from "@/constants/local-storage";

/**
 * Hook to resolve practiceId from multiple sources in priority order:
 * 1. URL params
 * 2. Encounter's meta.compartment (Organization reference)
 * 3. localStorage fallback
 */
export function usePracticeId(encounter?: Encounter): string | undefined {
  const { practiceId: practiceIdFromParams } = useParams<{ practiceId?: string }>();

  return useMemo(() => {
    // First try URL params
    if (practiceIdFromParams) {
      return practiceIdFromParams;
    }

    // Then try encounter's meta.compartment (Organization reference)
    const orgCompartment = encounter?.meta?.compartment?.find((c) =>
      c.reference?.includes("Organization"),
    );
    const orgId = orgCompartment?.reference?.split("/")[1];
    if (orgId) {
      return orgId;
    }

    // Fallback to localStorage
    return localStorage.getItem(ORGANIZATION_ID) || undefined;
  }, [encounter, practiceIdFromParams]);
}
